import useSWRInfinite from "swr/infinite";
import type { GetContentsEpisodesPayload } from "~/payloads";

const getEndpoint = (seasonId: string) =>
  `/_/aa00/contents/${seasonId}/episodes`;

function makeGetKey(seasonId: string) {
  function getKey(
    pageIndex: number,
    prevData: null | GetContentsEpisodesPayload,
  ) {
    if (pageIndex === 0) {
      return getEndpoint(seasonId);
    }
    if (prevData && prevData.result[prevData.result.length - 1].freeViewable) {
      return `${getEndpoint(seasonId)}`;
    }
    return null;
  }

  return getKey;
}

export function useSeasonContents(seasonId: string) {
  return useSWRInfinite<GetContentsEpisodesPayload>(makeGetKey(seasonId));
}
